export const WHATSAPP_STORE_PHONE = "5531981020410";

export const WHATSAPP_DEFAULT_MESSAGE =
    "Olá! Vim diretamente do site para obter mais informações!";

export function openWhatsApp(message, phone = WHATSAPP_STORE_PHONE) {
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank", "noopener,noreferrer");
}

export function buildWholesaleCartWhatsAppMessage(cartItems) {
    const lines = (cartItems || []).map(
        (item) =>
            `- ${item.title} | Sabor: ${item.flavor} | Qtd: ${item.quantity}`
    );

    const itemsBlock =
        lines.length > 0 ? lines.join("\n") : "- (carrinho vazio)";

    return `ITENS do carrinho:\n${itemsBlock}\n\ndesejo obter preço de atacado`;
}
